"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.registerIcon = exports.BmIcon = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _element = require("@onviobr/element");

var _bmIcons = require("./bm-icons");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t", "\n\t\t"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t:host {\n\t\twidth: 24px;\n\t\theight: 24px;\n\t}\n\tsvg {\n\t\twidth: inherit;\n\t\theight: inherit;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var iconTypeConverter = {
  fromAttribute: function fromAttribute(value) {
    var _context;

    return _bmIcons.IconType[value] || ((0, _includes.default)(_context = (0, _values.default)(_bmIcons.IconType)).call(_context, value) ? value : undefined);
  },
  toAttribue: function toAttribue(value) {
    var _context2;

    return _bmIcons.IconType[value] || ((0, _includes.default)(_context2 = (0, _values.default)(_bmIcons.IconType)).call(_context2, value) ? value : '');
  }
};
var style = (0, _element.css)(_templateObject());

var BmIcon = /*#__PURE__*/function (_BlueElement) {
  (0, _inherits2.default)(BmIcon, _BlueElement);

  var _super = (0, _createSuper2.default)(BmIcon);

  function BmIcon() {
    var _context3;

    var _this;

    (0, _classCallCheck2.default)(this, BmIcon);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context3 = [this]).call(_context3, args));
    _this.type = void 0;
    return _this;
  }

  (0, _createClass2.default)(BmIcon, [{
    key: "render",
    value: function render() {
      return this.html(_templateObject2(), this.type ? (0, _bmIcons.iconForType)(this.type) : '');
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-icon';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        type: {
          converter: iconTypeConverter,
          reflect: true,
          attribute: true
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return style;
    }
  }]);
  return BmIcon;
}(_element.BlueElement);

exports.BmIcon = BmIcon;

var registerIcon = function registerIcon() {
  return (0, _element.register)(BmIcon);
};

exports.registerIcon = registerIcon;
